module.exports = __webpack_public_path__ + "static/media/picture6@2x.7154f745.png";